// the file holds all the types for our custom widgets, this way we don't have to repeat ourselves
// and worry about key names
export const WIDGET_KEYS = {
  // resource tag columns keys
  columnResourceStatus: "resourcestatuscolumn",
  columnResourceCategory: "resourcecategorycolumn",
  columnResourceTag: "resourcetagscolumn",
  columnResourceType: "resourcetypecolumn",
  columnResourceTagIcon: "resourcetagiconcolumn",

  // task tag columns keys
  columnTaskStatus: "taskstatuscolumn",
  columnTaskCategory: "taskcategorycolumn",
  columnTaskPhase: "taskphasecolumn",
  columnTaskTag: "tasktagscolumn",
  columnTaskBudgetTitle: "taskbudgettitlecolumn",
  columnTaskClient: "taskclientcolumn",

  // client tag columns keys
  columnClientCategory: "clientcategorycolumn",
  columnClientTag: "clienttagscolumn",
  columnClientStatus: "clientstatuscolumn",

  // contact tag columns keys
  columnContactStatus: "contactstatuscolumn",
  columnContactCategory: "contactcategorycolumn",
  columnContactTag: "contacttagscolumn",

  columnUrl: "urlColumn",

  // icon and label field column
  columnEntityMainName: "columnEntityMainName",

  columnResourceBlackout: "columnResourceBlackout",

  columnTaskBudget: "columnTaskBudget",
  columnTaskBudgetAmount: "columnTaskBudgetAmount",
  columnTaskBudgetPercentage: "columnTaskBudgetPercentage",
  columnTaskBudgetText: "columnTaskBudgetText",

  // fields key
  fieldUrl: "swivuUrlField",
  fieldEmail: "swivuEmailField",
  fieldIcon: "swivuIconsField",
  fieldPhone: "swivuPhoneField",
  fieldCopy: "swivuTextCopyField",
  fieldPassword: "swivuPasswordField",
  fieldThemePicker: "themepicker",
  colorField: "swivucolorfield",
  settingsCombo: "swivusettingscombo",

  // editor widgets keys
  timeEventEditorType: "swivutimeeventeditor",

  manageViewEditorType: "swivumanagevieweditor",
  copyEntityEditorType: "swivucopyentityeditortype",
  saveViewEditorType: "swivusavevieweditortype",
  companyCamProjectType: "swivucampanycamproject",

  // tab
  swivuGrid: "swivuGrid",
  swivuPreferenceStyleGrid: "swivuPreferenceStyleGrid",

  //message widget key
  swivuMessageType: "swivumessage",

  //agenda message widget key
  agendaMessageType: "swivuagendamessage",

  //team columns
  teamField: "teamscombo",

  //scheduled column
  scheduledColumn: "taskscheduledcolumn",

  alertBellColumn: "alertBellColumn",
  reminderRecipientsColumn: "reminderrecipientscolumn",
  notifyColumn: "notifycolumn",
  checklistColumn: "checklistcolumn",
  contactColumn: "contactColumn",

  imageColumn: "imagecolumn",
  commentColumn: "commentcolumn",

  swivuLinkText: "swivuLinkText",

  columnPhoneNumber: "phonenumbercolumn",

  swivuNoteChangeRoleColumn: "swivunotechangerolecolumn",

  swivuUserGrantViewButtonColumn: "swivuusergrantviewbuttoncolumn",


  swivuSettingEditorPopup: "swivusettingeditorpopup",

  swivuChecklistItemEditorPopup: "swivuchecklistitemeditorpopup",
  swivuBoardAlertEditor: "swivuboardalerteditor",

  swivuContactFinderPopup: "swivucontactfinderpopup",

  budgetAccountColumn: "budgetAccountColumn",
  assignToColumn: "assigntocolumn",
  swivuSortColumn: "swivusortcolumn",
  recurringIntervalColumn: "recurringintervalcolumn",
  userRoleColumn: "userrolecolumn",
  swivuStateColumn: "swivustatecolumn",
  notifyBoardUserColumn: "notifyboardusercolumn",
  swivuBudgetEditor: "swivubudgeteditor",
  importedFieldsColumn: "importedfieldscolumn",
  collapsibleColumn: "collapsibleColumn",

  swivuViewInspectorEditor: "swivuviewinspectoreditor",

  // Notes and Files columns
  notesColumn: "notescolumn",
  filesColumn: "filescolumn",
  swivuAddressContainer: "swivuAddressContainer",
  swivuAddressPicker: "swivuaddresspicker",
  swivuAddressColumn: "swivuaddresscolumn",
  swivuModernGrid: "swivumoderngrid",

  incentivePointsStatusColumn: "incentivepointsstatuscolumn",
  eligibleUserColumn: "eligibleusercolumn",
  incentiveUserPermissionColumn: "incentiveuserpermissioncolumn",
  incentiveRolePermissionColumn: "incentiverolepermissioncolumn",
  incentiveCategoryColumn: "incentivecategorycolumn",

  notifyTabUserColumn: "notifytabusercolumn",

  swivuUserOwnershipColumn: "swivuuserownershipcolumn",
  swivuUserOwnershipGrid: "swivuuserownershiptgrid",
};
